export default __webpack_public_path__ + "static/media/ukraine.83b7bb4e.png";